export default "__VITE_ASSET__C7FNW84Y__"